import {oidcConfig} from "../utils/oidcConfig";
import http from './http.api';
import filehttp from './http.api';
const SHAREFILE_TEST_BASE_URL = process.env.REACT_APP_SHAREFILE_BASE_URL || '';
 
export const logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    const logouturl = `${oidcConfig.authority}/oauth2/logout/?client_id=${oidcConfig.client_id}&redirect_uri=${oidcConfig.logout_redirect_uri}`;
    window.location.href = logouturl;
};

export const getCarLookup = async (projectId: string) => {
  try {
    const url = `/v1/Lookup/create-car?projectId=${projectId}`;
    const response = await http.get(url);
    return response.data;
  } catch (error) {
    console.error('Error creating car:', error);
    throw error;
  }
};

export const updateCorrectiveActionRequest = async (projectId: string, requestData: object) => {
  try {
    const url = `/v1/CorrectiveActionRequest/${projectId}`;
    const response = await http.post(url, requestData);
    return response.data;
  } catch (error) {
    console.error('Error updating corrective action request:', error);
    throw error;
  }
};

export const updateCorrectiveActionRequestform = async (carId: string, requestData: object) => {
  try {
    const url = `/v1/CorrectiveActionRequest/${carId}`;
    const response = await http.put(url, requestData);
    return response.data;
  } catch (error) {
    console.error('Error updating corrective action request:', error);
    throw error;
  }
};

export const uploadShareFile = async (file: File) => {
  try {
    const url = `${SHAREFILE_TEST_BASE_URL}/api/ShareFile/upload-file-stream?shareFileFolderPath=test1%2Finner`;

    const formData = new FormData();
    formData.append('file', file.name);

    const response = await filehttp.post(url, formData, {
      headers: {
        'FileName': file.name,
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading file to ShareFile:', error);
    throw error;
  }
};

export const getCarmessages = async (carId: string) => {
  try {
    const url = `/v1/Messaging/car/${carId}/loggedinuser/messages`;
    const response = await http.get(url);
    return response.data;
  } catch (error) {
    console.error('Error creating car:', error);
    throw error;
  }
};


export const postCarmessages = async (requestData: object) => {
  try {
    const url = `/v1/Messaging`;
    const response = await http.post(url, requestData);
    return response.data;
  } catch (error) {
    console.error('Error creating car:', error);
    throw error;
  }
};

export const getDashboard = async () => {
  try {
    const url = `/v1/AuditorDashBoard`;
    const response = await http.get(url);
    return response.data;
  } catch (error) {
    console.error('Error get Dashboard :', error);
    throw error;
  }
};